import { useEffect, useState } from 'react';

export const useAnimation = (animationSpeed, isFrozen) => {
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    let animationId;
    let lastTime = performance.now();
    let accumulator = 0;
    
    const animate = (currentTime) => {
      if (isFrozen) {
        animationId = requestAnimationFrame(animate);
        return;
      }
      
      const deltaTime = (currentTime - lastTime) / 1000;
      lastTime = currentTime;
      
      accumulator += deltaTime / animationSpeed;
      accumulator = accumulator % (Math.PI * 2);
      
      setFrame(accumulator);
      
      animationId = requestAnimationFrame(animate);
    };
    
    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, [animationSpeed, isFrozen]);

  return frame;
};